require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./two-things-are-infinite-2.json") })
        }
      }, "path---two-things-are-infinite-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---two-things-are-infinite-2!./.cache/json/two-things-are-infinite-2.json
// module id = 853
// module chunks = 231608221292675